import { createContext, useContext, useState, useRef, useEffect } from 'react'

const PredictContext = createContext()

export const usePredictContext = () => {
    return useContext(PredictContext)
}

export const PredictContextProvider = ({ children }) => {

    const [assistant, setAssistant] = useState(null)
    const [timeFrame, setTimeFrame] = useState("")
    const [currentStep, setCurrentStep] = useState("entry")
    const [ticker, setTicker] = useState('')
    const [responseType, setResponseType] = useState('lite')
    const [shouldRefetch, setShouldRefetch] = useState(false)
    const [predictHistoryId, setPredictHistoryId] = useState(null)
    const [isLocked, setIsLocked] = useState(false)

    // --- ASYNC SETTER IMPLEMENTATION ---
    const assistantResolverRef = useRef(null)

    const setAssistantAsync = (value) => {
        return new Promise((resolve) => {
            assistantResolverRef.current = resolve
            setAssistant(value)
        })
    }

    useEffect(() => {
        if (assistantResolverRef.current) {
            assistantResolverRef.current()
            assistantResolverRef.current = null
        }
    }, [assistant])

    const reset = () => {
        setResponseType("lite")
        setTicker("")
        setTimeFrame("15")
        setAssistant(null)
        setCurrentStep("entry")
        setPredictHistoryId(null)
    }

    return (
        <PredictContext.Provider
            value={{
                assistant: { assistant, setAssistant, setAssistantAsync },
                step: { currentStep, setCurrentStep },
                timeFrame,
                setTimeFrame,
                ticker,
                setTicker,
                refetch: { shouldRefetch, setShouldRefetch },
                responseType,
                setResponseType,
                reset,
                predictHistory: { predictHistoryId, setPredictHistoryId },
                isLocked, setIsLocked
            }}
        >
            {children}
        </PredictContext.Provider>
    )
}
